<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Create Case
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <form class="form form-horizontal mt-2" ref="createCaseModal">
              <div class="row">
                <div class="col-md-4 col-sm-12">
                  <div class="form-group">
                    <label for="account-name">Case Title</label>

<!--                    <input type="text" v-validate="'required'" v-model="title" class="form-control" id="account-name" name="title"-->
<!--                           placeholder="Name"/>-->
<!--                    <small-->
<!--                        v-show="errorBag.has('title')"-->
<!--                        class="invalid-feedback"-->
<!--                    >{{ "*" + errorBag.first("title") }}</small-->
<!--                    >-->
                    <input
                        type="text"
                        v-model="title"
                        id="name-icon"
                        class="form-control"
                        :class="
                                  errorBag.has('title') ? 'is-invalid' : ''
                                "
                        name="title"
                        placeholder="Name"
                        v-validate="'required'"
                    />
                    <small
                        v-show="errorBag.has('title')"
                        class="invalid-feedback"
                    >{{ "*" + errorBag.first("title") }}</small
                    >
                  </div>
                </div>
                <div class="col-md-4 col-sm-12">
                  <div class="form-group">
                    <label for="account-name">Case Type</label>
                    <select class="form-control" v-model="type">
                      <option value="normal">Normal</option>
                      <option value="urgent">Urgent</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4 col-sm-12">
                  <div class="form-group">
                    <label for="account-name">Risk Score</label>
                    <input v-model="transactionRiskScore" type="text" class="form-control" id="account-name" name="name"
                           placeholder="Number"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="account-name">Description</label>
                    <textarea
                        type="text"
                        v-model="description"
                        class="form-control"
                        :class="
                                  errorBag.has('description') ? 'is-invalid' : ''
                                "
                        name="description"
                        placeholder="notes"
                        v-validate="'required'"
                    />
                    <small
                        v-show="errorBag.has('description')"
                        class="invalid-feedback"
                    >{{ "*" + errorBag.first("description") }}</small
                    >
                  </div>
                </div>

              </div>
              <div class="row d-flex justify-content-center">
                <div class="col-md-8 col-sm-12">
                  <div class="form-group">
                   <div class="row">
                     <div class="col-md-8 col-sm-12">
                       <label for="account-name">Transaction ID</label>
                       <input
                           type="text"
                           v-model="transactionId"
                           id="name-icon"
                           class="form-control"
                           :class="
                                  errorBag.has('transactionId') ? 'is-invalid' : ''
                                "
                           name="transactionId"
                           placeholder="Search..."
                           v-validate="'required'"
                       />
                       <small
                           v-show="errorBag.has('transactionId')"
                           class="invalid-feedback"
                       >{{ "*" + errorBag.first("transactionId") }}</small
                       >
                     </div>
                     <div class="col-md-2 col-sm-12">
                       <button type="button" class="btn btn-primary btn-sm mt-2" @click="getTransactionsDetails" >search</button>
                     </div>
                   </div>

                  </div>
                </div>
<!--                <div class="col-md-2 col-sm-12">-->
<!--                  <div class="form-group">-->
<!--                    <label >Search</label>-->
<!--                    <button type="button" class="btn btn-primary btn-sm" @click="getTransactionsDetails">search</button>-->
<!--                  </div>-->
<!--                </div>-->

              </div>
              <div class="row d-flex justify-content-center mb-3">
                <div class="col-md-8 col-sm-12">
                  <div class="collapse-border " id="accordionExample">
                    <div class="card">
                      <div class="card-header collapsed" id="headingOne" data-toggle="collapse" role="button"
                           data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        <span class="lead collapse-title"><div class="spinner-border spinner-border-sm text-primary" v-show="transctionDetailLoading"></div> Transaction Details      <feather type="arrow-down"
                                                                                             class=" font-weight-bolder text-md"></feather>  </span>
                      </div>

                      <div id="collapseOne" class="collapse" aria-labelledby="headingOne"
                           data-parent="#accordionExample"
                           style="">
                        <section  class="invoice-preview-wrapper" v-if="transactionDetails && !isEmpty(transactionDetails)">
                          <div class="row invoice-preview">
                            <!-- Invoice -->
                            <div class="col-12">
                              <div class="card invoice-preview-card">
                                <div class="card-body invoice-padding pb-0">
                                  <!-- Header starts -->
                                  <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                                    <div>
                                      <div class="logo-wrapper">
                                        <h3><img width="150" :src="`${publicPath}vaults-authlogo.png`"></h3>
                                      </div>
                                      <p class="card-text mb-25">Payment Method: {{ transactionDetails.payment_method?transactionDetails.payment_method.name:'N/A' }}</p>
                                      <p class="card-text mb-25">Gateway Ref Id:
                                        {{ transactionDetails.gateway_reference_id ? transactionDetails.gateway_reference_id : 'N/A' }}</p>
                                      <p class="card-text mb-25">Ref Id:
                                        {{ transactionDetails.reference_id ? transactionDetails.reference_id : 'N/A' }}</p>
                                      <p class="card-text mb-0">Transaction Type: {{ transactionDetails.transaction_type? transactionDetails.transaction_type.name:'N/A' }}</p>
                                      <p class="card-text mb-0" v-if="transactionDetails.settlement_status == 1">Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-info">INITIATED</span></p>
                                      <p class="card-text mb-0" v-else-if="transactionDetails.settlement_status == 2">Settlement Status: <span class="badge badge-pill mt-1  badge-glow badge-danger">CANCELED</span></p>
                                      <p class="card-text mb-0" v-else-if="transactionDetails.settlement_status == 3">Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-success">DONE</span></p>
                                      <p class="card-text mb-0" v-else>Settlement Status:  <span class="badge badge-pill mt-1  badge-glow badge-warning">PENDING</span></p>

                                      <p class="card-text mb-25" v-if="transactionDetails.status == 1">Transaction Status:  <span class="badge  mt-1  badge-glow badge-info">Success</span></p>
                                      <p class="card-text mb-25" v-else-if="transactionDetails.status == 2">Transaction Status: <span class="badge  mt-1  badge-glow badge-danger">Failed</span></p>
                                      <p class="card-text mb-25" v-else> Transaction Status:  <span class="badge  mt-1  badge-glow badge-warning">PENDING</span></p>
                                      <p class="card-text mb-25 mt-1">Aquiring: {{ transactionDetails.aquiring?transactionDetails.aquiring.name+'/'+transactionDetails.aquiring.code:'N/A' }}</p>
                                      <p class="card-text mb-25 mt-1">Schema: {{ transactionDetails.schema?transactionDetails.schema.name+'/'+transactionDetails.schema.code:'N/A' }}</p>
                                      <p class="card-text mb-25 mt-1">Channel: {{ transactionDetails.channel?transactionDetails.channel.name+'/'+transactionDetails.channel.code:'N/A' }}</p>
                                      <p class="card-text mb-25 mt-1">Country: {{ transactionDetails.country_code?transactionDetails.country_code:'N/A' }}</p>
                                      <p class="card-text mb-25 mt-1">Approval Code: {{ transactionDetails.approval_code?transactionDetails.approval_code:'N/A' }}</p>
                                      <p class="card-text mb-25 mt-1" v-if="typeof(transactionDetails.ip_address) != 'undefined'">IP Address: {{  transactionDetails.ip_address?transactionDetails.ip_address:'N/A' }}</p>
                                      <p class="card-text mb-25 mt-1" v-if="typeof(transactionDetails.client_reference) != 'undefined'">Client Reference: {{ transactionDetails.client_reference?transactionDetails.client_reference:'N/A' }}</p>
                                      <p class="card-text mb-25 mt-1" v-if="typeof(transactionDetails.payment_link) != 'undefined'">Callback Url: {{ transactionDetails.payment_link?(transactionDetails.payment_link.callback_url && transactionDetails.payment_link.callback_url != ''?transactionDetails.payment_link.callback_url:'N/A') :'N/A' }}</p>
                                      <p class="card-text mb-25 mt-1" v-if="typeof(transactionDetails.payment_link) != 'undefined'">Redirect Url: {{ transactionDetails.payment_link?(transactionDetails.payment_link.redirect_url && transactionDetails.payment_link.redirect_url != ''?transactionDetails.payment_link.redirect_url:'N/A') :'N/A' }}</p>
                                    </div>
                                    <div class="mt-md-0 mt-2">
                                      <h4 class="invoice-title mb-0">
                                        Transaction
                                        <span class="invoice-number">#{{$route.params.id}}</span>
                                      </h4>
                                      <h6 v-if="transactionDetails.application == 'DIRECT_API_PAYMENT'" class="invoice-title ">
                                        <span class="badge badge-light-info">Direct Api Payment</span>
                                      </h6>
                                      <div class="invoice-date-wrapper justify-content-end">
                                        <p class="invoice-date-title">Date Created:</p>
                                        <p class="invoice-date">{{
                                            new Date(transactionDetails.created_at).toISOString().slice(0, 16).replace('T', ' ')
                                          }}</p>

                                      </div>
                                      <div class="justify-content-end d-flex" v-if="transactionDetails.process_manually_by">
                                        <p class=""><span class="badge badge-success">Processed Manually</span></p>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Header ends -->
                                </div>

                                <hr class="invoice-spacing mt-0" v-if="showAdjustmentDescription(transactionDetails)" />

                                <div class="card-body invoice-padding py-0" v-if="showAdjustmentDescription(transactionDetails)">
                                  <!-- Invoice Note starts -->
                                  <div class="row">
                                    <div class="col-8">
                                      <div class="form-group mb-2">
                                        <label  class="form-label font-weight-bold text-primary">Adjustment Description:</label>
                                        <textarea disabled="true" class="form-control" rows="2" >
                          {{transactionDetails.other_details.description}}
                        </textarea>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Invoice Note ends -->
                                </div>

                                <hr class="invoice-spacing"/>


                                <div class="card-body invoice-padding pt-0">
                                  <div class="row invoice-spacing">
                                    <div class="col-xl-8 p-0">
                                      <h6 class="mb-2">Sender Details:</h6>
                                      <h6 class="mb-25">Name: {{transactionDetails.sender.first_name + ' '+ transactionDetails.sender.last_name }}</h6>
                                      <p class="card-text mb-25">Email: {{transactionDetails.sender.email}} </p>
                                      <p class="card-text mb-25">Account title: {{transactionDetails.sender_account_title}}</p>
                                      <p class="card-text mb-25">Account Number: {{transactionDetails.sender_account_number}}</p>
                                      <p class="card-text mb-25">Customer Email: {{transactionDetails.customer?transactionDetails.customer.email:'N/A'}}</p>
                                      <p class="card-text mb-25">Customer Name: {{transactionDetails.customer?transactionDetails.customer.name:'N/A'}}</p>
                                      <p class="card-text mb-25">Customer Phone: {{transactionDetails.customer?transactionDetails.customer.phone:'N/A'}}</p>
                                    </div>
                                    <div class="col-xl-4 p-0 mt-xl-0 mt-2">
                                      <h6 class="mb-2">Receiver Details:</h6>
                                      <h6 class="mb-25">Name: {{transactionDetails.receiver.first_name + ' '+ transactionDetails.receiver.last_name }}</h6>
                                      <p class="card-text mb-25">Email: {{transactionDetails.receiver.email}} </p>
                                      <p class="card-text mb-25">Account title: {{transactionDetails.receiver_account_title}}</p>
                                      <p class="card-text mb-25">Account Number: {{transactionDetails.receiver_account_number}}</p>
                                    </div>
                                  </div>
                                </div>


                                <div class="card-body invoice-padding pb-0 mt-5">
                                  <div class="row invoice-sales-total-wrapper">
                                    <div class="col-md-4 order-md-1 order-2 mt-md-0 mt-3">

                                    </div>
                                    <div class="col-md-8 d-flex justify-content-end order-md-2 order-1">
                                      <div class="invoice-total-wrapper">
                                        <div class="invoice-total-item">
                                          <p class="invoice-total-title">Actual Amount:</p>
                                          <p class="invoice-total-amount" v-if="transactionDetails.amount != transactionDetails.total_amount">{{ parseFloat(transactionDetails.total_amount / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                                          <p class="invoice-total-amount" v-else>{{ parseFloat(transactionDetails.amount / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                                        </div>
                                        <div class="invoice-total-item">
                                          <p class="invoice-total-title">Vat:</p>
                                          <p class="invoice-total-amount">
                                            {{ parseFloat(transactionDetails.vat / 100).toFixed(feesDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                                        </div>
                                        <div class="invoice-total-item">
                                          <p class="invoice-total-title">Fee:</p>
                                          <p class="invoice-total-amount">
                                            {{ parseFloat(transactionDetails.fee / 100).toFixed(feesDecimalPlaces)+ ' ' + transactionDetails.currency.code  }}</p>
                                        </div>
                                        <hr class="my-50"/>
                                        <div class="invoice-total-item">
                                          <p class="invoice-total-title">Payable Amount:</p>
                                          <p class="invoice-total-amount text-danger" v-if="transactionDetails.transaction_type_id == 6">- {{parseFloat((parseFloat(transactionDetails.amount)+parseFloat(transactionDetails.vat)+parseFloat(transactionDetails.fee))/100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code }}</p>
                                          <p class="invoice-total-amount" v-else-if="transactionDetails.amount != transactionDetails.total_amount">{{ parseFloat((transactionDetails.amount) / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                                          <p class="invoice-total-amount" v-else>{{ parseFloat((transactionDetails.amount - transactionDetails.vat - transactionDetails.fee) / 100).toFixed(amountDecimalPlaces) + ' ' + transactionDetails.currency.code  }}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>


                                <hr class="invoice-spacing"/>


                              </div>
                            </div>
                            <!-- /Invoice -->

                          </div>
                        </section>
<!--                        <section class="invoice-preview-wrapper p-1">-->
<!--                          <div class="row invoice-preview">-->
<!--                            <div class="col-12">-->
<!--                              <div class="card invoice-preview-card">-->
<!--                                <div class="card-body invoice-padding p-2">-->
<!--                                  <div-->
<!--                                      class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">-->
<!--                                    <div>-->
<!--                                      <div class="logo-wrapper">-->
<!--                                        <h3><img width="150" src="/vaults-authlogo.png"></h3>-->
<!--                                      </div>-->
<!--                                      <p class="card-text mb-25">Payment Method: Cyberso</p>-->
<!--                                      <p class="card-text mb-25">Gateway Ref Id: N/A</p>-->
<!--                                      <p class="card-text mb-25">Ref Id: N/A</p>-->
<!--                                      <p class="card-text mb-0">Transaction Type: Transfer</p>-->
<!--                                      <p class="card-text mb-0">Settlement Status: <span-->
<!--                                          class="badge badge-pill mt-1  badge-glow badge-warning">PENDING</span></p>-->
<!--                                      <p class="card-text mb-25">Transaction Status: <span-->
<!--                                          class="badge  mt-1  badge-glow badge-info">Success</span></p>-->
<!--                                      <p class="card-text mb-25 mt-1">Aquiring: CBD ETI USERs /AQR_02</p>-->
<!--                                      <p class="card-text mb-25 mt-1">Schema: Visa / Master / AED/SCM_01</p>-->
<!--                                      <p class="card-text mb-25 mt-1">Channel: N/A</p>-->
<!--                                      <p class="card-text mb-25 mt-1">Country: N/A</p>-->
<!--                                      <p class="card-text mb-25 mt-1">Approval Code: N/A</p>-->
<!--                                      <p class="card-text mb-25 mt-1">IP Address: 39.59.22.189</p>-->
<!--                                      <p class="card-text mb-25 mt-1">Client Reference: N/A</p>-->
<!--                                      <p class="card-text mb-25 mt-1">Callback Url: N/A</p>-->
<!--                                      <p class="card-text mb-25 mt-1">Redirect Url: N/A</p>-->
<!--                                    </div>-->
<!--                                    <div class="mt-md-0 mt-2">-->
<!--                                      <h4 class="invoice-title mb-0"> Transaction <span-->
<!--                                          class="invoice-number">#TR_P3DRVJB9UBNYT</span></h4>-->
<!--                                      &lt;!&ndash;&ndash;&gt;-->
<!--                                      <div class="invoice-date-wrapper justify-content-end">-->
<!--                                        <p class="invoice-date-title">Date Created:</p>-->
<!--                                        <p class="invoice-date">2023-12-27 08:02</p>-->
<!--                                      </div>-->
<!--                                      &lt;!&ndash;&ndash;&gt;-->
<!--                                    </div>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                                &lt;!&ndash;&ndash;&gt;&lt;!&ndash;&ndash;&gt;-->
<!--                                <hr class="invoice-spacing">-->
<!--                                <div class="card-body invoice-padding pt-0">-->
<!--                                  <div class="row invoice-spacing">-->
<!--                                    <div class="col-xl-8 p-0">-->
<!--                                      <h6 class="mb-2">Sender Details:</h6>-->
<!--                                      <h6 class="mb-25">Name: Uzair Uzair</h6>-->
<!--                                      <p class="card-text mb-25">Email: uzair@vaultspay.ae </p>-->
<!--                                      <p class="card-text mb-25">Account title: UZAIR UZAIR AED</p>-->
<!--                                      <p class="card-text mb-25">Account Number: AED014983848943</p>-->
<!--                                      <p class="card-text mb-25">Customer Email: N/A</p>-->
<!--                                      <p class="card-text mb-25">Customer Name: N/A</p>-->
<!--                                      <p class="card-text mb-25">Customer Phone: N/A</p>-->
<!--                                    </div>-->
<!--                                    <div class="col-xl-4 p-0 mt-xl-0 mt-2">-->
<!--                                      <h6 class="mb-2">Receiver Details:</h6>-->
<!--                                      <h6 class="mb-25">Name: Rashid Latif</h6>-->
<!--                                      <p class="card-text mb-25">Email: rashid@vaultspay.ae </p>-->
<!--                                      <p class="card-text mb-25">Account title: RASHID LATIF AED</p>-->
<!--                                      <p class="card-text mb-25">Account Number: AED00554175274</p>-->
<!--                                    </div>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                                <div class="card-body invoice-padding pb-0 mt-5">-->
<!--                                  <div class="row invoice-sales-total-wrapper">-->
<!--                                    <div class="col-md-4 order-md-1 order-2 mt-md-0 mt-3"></div>-->
<!--                                    <div class="col-md-8 d-flex justify-content-end order-md-2 order-1">-->
<!--                                      <div class="invoice-total-wrapper">-->
<!--                                        <div class="invoice-total-item">-->
<!--                                          <p class="invoice-total-title">Actual Amount:</p>-->
<!--                                          <p class="invoice-total-amount">11.000 AED</p>-->
<!--                                        </div>-->
<!--                                        <div class="invoice-total-item">-->
<!--                                          <p class="invoice-total-title">Vat:</p>-->
<!--                                          <p class="invoice-total-amount"> 0.000 AED</p>-->
<!--                                        </div>-->
<!--                                        <div class="invoice-total-item">-->
<!--                                          <p class="invoice-total-title">Fee:</p>-->
<!--                                          <p class="invoice-total-amount"> 0.000 AED</p>-->
<!--                                        </div>-->
<!--                                        <hr class="my-50">-->
<!--                                        <div class="invoice-total-item">-->
<!--                                          <p class="invoice-total-title">Payable Amount:</p>-->
<!--                                          <p class="invoice-total-amount">11.000 AED</p>-->
<!--                                        </div>-->
<!--                                      </div>-->
<!--                                    </div>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                                <hr class="invoice-spacing">-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </section>-->
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-4 col-sm-12">
                  <div class="form-group">
                    <!--                    <label for="account-name">Department</label>-->
                    <!--                    <select class="form-control" v-model="department">-->
                    <!--                      <option>Finance</option>-->
                    <!--                      <option>Compliance</option>-->
                    <!--                      <option>Accounts</option>-->
                    <!--                    </select>-->
                    <SelectOptions
                        label="Department"
                        selectAppend="department"
                        labelValue="name"
                        :filter="{limit:0}"
                        :modelValue.sync="selectedDepartment"
                        :url="getDepartmentsUrl"
                    />
                  </div>
                </div>
                <div class="col-md-4 col-sm-12">
                  <div class="form-group">
                    <label for="account-name">Sub Department</label>
                    <select class="form-control" v-model="selectedSubDepartment">
                      <option value="null">Select sub department</option>
                      <option v-for="(item,index) in subDepartments" :value="item._id">{{ item.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4 col-sm-12">
                  <div class="form-group">
                    <label for="account-name">Assign To</label>
<!--                    <multiselect-->
<!--                        v-model="assignedTo"-->
<!--                        :options="MerchantsData"-->
<!--                        label="label"-->
<!--                        track-by="id"-->
<!--                        placeholder="Select Assignee"-->
<!--                        variant="primary"-->
<!--                        :custom-label="customNameForMultiselect"-->
<!--                    ></multiselect>-->
                    <select class="form-control" v-model="assignedTo">
                      <option value="null">Select assignee</option>
                      <option v-for="(item,index) in assigneeList" :value="item._id">{{ item.name }}</option>
                    </select>
                  </div>


                </div>
              </div>
              <div class="row" v-if="assignedTo">
                <div class="col-12">
                  <div class="form-group">
                    <label for="account-name">Comments</label>
<!--                    <textarea v-validate="'required'" v-model="comments" rows="3" class="form-control"-->
<!--                              id="" name="comments" placeholder="comments"></textarea>-->
                    <textarea
                        type="text"
                        v-model="comments"
                        class="form-control"
                        :class="
                                  errorBag.has('comments') ? 'is-invalid' : ''
                                "
                        name="comments"
                        placeholder="comments"
                        v-validate="'required'"
                    />
                    <small
                        v-show="errorBag.has('comments')"
                        class="invalid-feedback"
                    >{{ "*" + errorBag.first("comments") }}</small
                    >
                  </div>
                </div>

              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-center">
            <button
                type="button"
                class="btn btn-primary mr-1 d-flex mt-2"
                @click="sendCall"
                :disabled="loading"
            >
              <Loader :loading="loading" :size="size"></Loader>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    // this.getMerchantData()
  },
  props: ['show', 'data', 'index'],
  data() {
    return {
      size:'10px',
      subDepartments: [],
      selectedSubDepartment: null,
      selectedDepartment: null,
      list: [],
      type: 'normal',
      title: '',
      transactionRiskScore: 0,
      transactionId: '',
      department: null,
      assignedTo: null,
      getDepartmentsUrl: "v1/cms-get-department",
      MerchantsData: [],
      description: '',
      assigneeList:[],
      transactionDetails:[],
      comments:'',
      loading: false,
      transctionDetailLoading:false

      // showModal: false,
    };
  },
  created() {
    this.initialCreateCaseState = JSON.parse(JSON.stringify(this.$data));
  },
  methods: {
    resetToInitialState() {
      Object.keys(this.initialCreateCaseState).forEach(key => {
        this.$data[key] = JSON.parse(JSON.stringify(this.initialCreateCaseState[key]));
      });
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            title:this.title,
            subDepartment: this.selectedSubDepartment,
            transactionRiskScore: this.transactionRiskScore,
            type:this.type,
            discription: this.description

          }

          if(this.transactionDetails && !this.isEmpty(this.transactionDetails)){
            // data.merchant = JSON.stringify(this.transactionDetails?.receiver)
            data.merchant = {'name':this.transactionDetails?.receiver.first_name,'uuid':this.transactionDetails?.receiver?.uuid}

            let transaction = {
              uuid: this.transactionId,
              referenceId:this.transactionDetails?.reference_id,
              gatewayRefId: this.transactionDetails?.gateway_reference_id,
              approvalCode: this.transactionDetails?.approval_code,
              transactionDateTime: this.transactionDetails?.created_at,
              transactionType: this.transactionDetails?.transaction_type,
              status: this.transactionDetails?.status,
              amount: this.transactionDetails?.amount,
              fee: this.transactionDetails?.fee,
              vat: this.transactionDetails?.vat,
              country: this.transactionDetails?.country_code,
              ipAddress: this.transactionDetails?.ip_address,
              clientReference: this.transactionDetails?.client_reference,
              callbackUrl: this.transactionDetails?.payment_link?.callback_url,
              redirectUrl: this.transactionDetails?.payment_link?.redirect_url,
              paymentMethod: this.transactionDetails?.payment_method,
              aquirer: this.transactionDetails?.aquirer,
              schema: this.transactionDetails?.schema,
              channel: this.transactionDetails?.channel,
              sender: this.transactionDetails?.sender,
              receiver: this.transactionDetails?.receiver
            }
            data.transaction = JSON.stringify(transaction)
          }




          if(this.assignedTo){
            data.assignedTo = {id: this.assignedTo,comments: this.comments}
          }

          let url = 'v1/cms-create-case'


          this.makeRequest("post", url, data).then(callResponse => {
            this.loading = false;
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.$emit('completed',callResponse.response.data.data)
              }
            }
          });
        }
      });
    },
    showAdjustmentDescription(transactions){
      if(transactions.other_details){
        if(typeof(transactions.other_details.description) != 'undefined'){
          if(transactions.other_details.description != ''){
            return true
          }
        }
      }

      return false
    },
    // customNameForMultiselect({email, first_name}) {
    //   return `${email} ${first_name}`
    // },
    // getMerchantData() {
    //   this.makeRequest("post", "v1/get-merchants", {flag: 'all', type: 3}, {}, false, true, [205]).then(
    //       (callResponse) => {
    //         if (!callResponse.error) {
    //           let code = callResponse.response.data.code;
    //           let responseData = callResponse.response.data.data;
    //           if (code == 200) {
    //             this.MerchantsData = responseData;
    //             this.setSelectedMerchantValue();
    //           }
    //         }
    //       }
    //   );
    // },
    // setSelectedMerchantValue() {
    //
    //
    //   if (this.selectedSender == null && this.MerchantsData.length > 0) {
    //     this.selectedSender = this.MerchantsData[0];
    //
    //   }
    //
    //   if (this.selectedReceiver == null && this.MerchantsData.length > 0) {
    //     this.selectedReceiver = this.MerchantsData[0];
    //
    //   }
    // },
    getTransactionsDetails() {
      this.transctionDetailLoading = true
      let data = {
        transactionId: this.transactionId,
        transactionDetail: 1
      }
      this.makeRequest("post", "v1/get-transaction", data, {}, false).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.transactionDetails = responseData
              }
            }
            this.transctionDetailLoading = false
          }
      );
    }
  },
  watch: {
    show() {
      this.$nextTick(() => {
        this.resetToInitialState()
      });
    },
    selectedDepartment(val) {
      this.selectedSubDepartment = null
      this.subDepartments = []
      if (val) {
        if (typeof val["subDepartments"] != "undefined") {
          this.subDepartments = val.subDepartments
          if (val.subDepartments.length > 0) {
            this.selectedSubDepartment = val.subDepartments[0]._id
            this.assignedTo = null
          }
        }
      }
    },
    selectedSubDepartment(val) {
      this.assignedTo = null
      let subdepartFullObj = []
      if(val){
        subdepartFullObj = this.selectedDepartment.subDepartments.filter(item=>{
          return item._id == val
        })

        if(subdepartFullObj.length > 0){
          this.assigneeList = subdepartFullObj[0]?.assignees
        }
      }

    },

  }
};
</script>

<style scoped>
.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}</style>
